import React, { useEffect, useRef } from "react";

import Play from "./Play";
import Pause from "./Pause";
import YourLove from "./yourlove.mp3";

import useAudioPlayer from "./useAudioPlayer";

import "./styles.scss";

function Audio() {
  const audioRef = useRef(null);
  const { playing, setPlaying } = useAudioPlayer(audioRef);

  useEffect(() => {
    setPlaying(true);
  }, [setPlaying]);

  return (
    <div className="player">
      <audio ref={audioRef} id="audio">
        <source src={YourLove} />
        Your browser does not support the <code>audio</code> element.
      </audio>
      <div className="controls">
        {playing ? (
          <Pause handleClick={() => setPlaying(false)} />
        ) : (
          <Play handleClick={() => setPlaying(true)} />
        )}
      </div>
    </div>
  );
}

export default Audio;
